import { Component, input, computed, ChangeDetectionStrategy } from '@angular/core';
import { ImageWidget } from '../../../../interfaces/view-widget';
import { NgTemplateOutlet } from '@angular/common';

@Component({
  selector: 'ol-image-widget',
  templateUrl: './image-widget.component.html',
  styleUrls: ['./image-widget.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgTemplateOutlet],
})
export class ImageWidgetComponent {
  widget = input.required<ImageWidget>();

  title = computed(() => this.widget().title || '');
  description = computed(() => this.widget().description || '');
  linkUrl = computed(() => this.widget().linkUrl || '');

  size = computed(() => this.widget().size || 'small');
  imageUrl = computed(() => this.widget().imageUrl || '');
}
